import { connect } from 'react-redux';
import { getInvoice } from 'redux/actions/InvoiceAction';
import { setLoading, setErrorState } from 'redux/actions/GeneralAction';

import { injectIntl } from 'react-intl';

import InvoicePage from './InvoicePage.page';

const page = injectIntl(InvoicePage);
const mapStateToProps = state => ({
  invoiceData: state.invoice.data,
});

const mapDispatchToProps = { getInvoice, setLoading, setErrorState };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(page);
